<template>
  <div class="g-flex g-flex-wrap g-flex-fs g-flex-top">
    <div v-for="(item,i) in arrayValue" :key="i" class="tags-item">
      <dic-select 
        :dic-array="dicArray" 
        :value="item" 
        filterable 
        class="g-width-100" 
        @input="setItem(i,$event)"/>
      <i class="el-icon-close tags-item-close" @click="removeItem(i)"/>
    </div>
    <el-button icon="el-icon-plus" circle @click="addItem"/>
  </div>
</template>
<script>
  import { dicSelect } from '../../dictionary/dictionary';

  export default {
    components: {
      dicSelect
    },
    data() {
      return {
        dicArray: []
      };
    },
    computed: {
      arrayValue: {
        get() {
          return this.value.split(',');
        },
        set(nValue) {
          console.log("onSet", nValue);
          this.$emit("input", nValue.join(','));
          this.dispatch("ElFormItem", "el.form.change", [nValue.join(',')]);
        }
      }
    },
    props: {
      value: {
        type: String,
        default: ""
      }
    },
    mounted() {
      console.log(123);
      this.initDataList();
    },
    methods: {
      setItem(i, e) {
        console.log(i, e);
        const temp = this.value.split(',');
        temp[i] = e;
        this.arrayValue = temp;
      },
      addItem() {
        this.$emit("input", this.value + ",");
        this.$parent.$emit("el.form.change");
      // this.dispatch("ElFormItem", "el.form.change", [this.value+","]);
      },
      removeItem(i) {
        const temp = this.value.split(',');
        temp.splice(i, 1);
        this.arrayValue = temp;
      },
      dispatch(componentName, eventName, params) {
        let parent = this.$parent || this.$root;
        let name = parent.$options.componentName;

        while (parent && (!name || name !== componentName)) {
          parent = parent.$parent;

          if (parent) {
            name = parent.$options.componentName;
          }
        }
        if (parent) {
          console.log(parent);
          parent.$emit(...[eventName].concat(params));
        }
      },
      initDataList() {
        this.$axios({
          method: 'post',
          url: '/resource/articleNavigate/getNavigateLevel.htm',
          data: {
            type: '4',
            tagType: '800',
            level: 1
          }
        }).then(req => {
          this.dicArray = req.data.map(v => ({
            id: v.id,
            label: v.name,
            value: v.id.toString()
          }));
        });
      }
    },
  };
</script>
<style lang="scss" scoped>
.tags-item{
  position: relative;
  margin-right: 20px;
  margin-bottom: 10px;
  &-close{
    position: absolute;
    right: 0;
    top: 0;
    transform: translate(50%,-50%);
    background: white;
    border-radius: 50%;
    border: 1px solid #999;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tags/index.vue